import React, { useCallback, useEffect, useState } from "react";
import HttpService from "../../services/HttpService";
import "../../css/index.css";
import "../../css/Pages.css";
import { Redirect, useHistory, useLocation } from "react-router-dom";
import RenderOnRole from "../../Utilities/RenderOnRole";
import { useTranslation } from 'react-i18next';

const AbonnementToevoegenPagina = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [abonnementTypes, setAbonnementTypes] = useState(null);
  const [abonnementType, setAbonnementType] = useState(null);
  const [klant, setKlant] = useState(null);
  const [abonnement, setAbonnement] = useState(null);
  const [abonnementId, setAbonnementId] = useState(null);
  const [aantal, setAantal] = useState(1);
  const [startdatum, setStartdatum] = useState(null);
  const [einddatum, setEinddatum] = useState(null);
  const [status, setStatus] = useState(null);
  const [responseMessage, setResponseMessage] = useState("");
  const [redirect, setRedirect] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);

  useEffect(() => {
    try {
      if (location.state?.selectedAbonnement) {
        setAbonnement(location.state.selectedAbonnement);
        setIsUpdate(true);
      }
    } catch (ex) {
      history.push("/");
    }

    const klantObj = location.state?.klantObject;
    if (!klantObj) {
      history.push("/");
      return;
    }

    setKlant(klantObj);

    const httpService = HttpService;
    httpService.configure();
    const axiosInstance = httpService.getAxiosClient();

    setLoading(true);
    setError(false);

    axiosInstance
      .get('/Abonnementen?types=true')
      .then((response) => {
        setAbonnementTypes(response.data);
        setAbonnementType(response.data[0]);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        setError(true);
      });
  }, [history, location.state]);

  useEffect(() => {
    if (abonnement && abonnementTypes && !loading) {
      setAbonnementId(abonnement.abonnementId);
      setAbonnementType(abonnement.abonnementType);
      setAantal(abonnement.aantal);
      setStartdatum(abonnement.startdatum);
      setEinddatum(abonnement.einddatum);
      setStatus(abonnement.status);
    }
  }, [abonnement, abonnementTypes, loading]);

  const postAbonnement = useCallback(() => {
    if (abonnementType == null) {
      setResponseMessage(t('subscriptions.noTypeSelected'));
      return;
    }
    if (aantal < 1) {
      setResponseMessage(t('subscriptions.invalidQuantity'));
      return;
    }

    let newStatus = "Inactief";
    const today = Date.now();
    if (startdatum != null && new Date(startdatum).getTime() <= today) {
      newStatus = "Actief";
    }
    if (einddatum != null && new Date(einddatum).getTime() <= new Date(startdatum).getTime()) {
      setResponseMessage(t('subscriptions.endDateBeforeStart'));
      return;
    }

    const httpService = HttpService;
    httpService.configure();
    const axiosInstance = httpService.getAxiosClient();

    const newAbonnement = {
      abonnementId: isUpdate ? abonnementId : 0,
      abonnementType: abonnementType,
      aantal: aantal,
      startdatum: startdatum,
      einddatum: einddatum,
      status: newStatus,
    };

    if (isUpdate) {
      //const url = `${process.env.REACT_APP_API_URL}/Abonnementen/${abonnementId}`;
      axiosInstance
        .put(`/Abonnementen/${abonnementId}`, newAbonnement)
        .then((response) => {
          if (response.status === 200) {
            setResponseMessage(t('subscriptions.updateSuccess'));
            setRedirect(true);
          }
        })
        .catch((error) => {
          setResponseMessage(error.toString());
        });
    } else {
      //const url = `${process.env.REACT_APP_API_URL}/Abonnementen/${klant.klantId}`;
      axiosInstance
        .post(`/Abonnementen/${klant.klantId}`, newAbonnement)
        .then((response) => {
          if (response.status === 200) {
            setResponseMessage(t('subscriptions.addSuccess'));
            setRedirect(true);
          }
        })
        .catch((error) => {
          setResponseMessage(error.toString());
        });
    }
  }, [abonnementType, aantal, startdatum, einddatum, isUpdate, abonnementId, klant]);

  const selectAbonnementOption = useCallback(() => {
    if (!abonnementTypes || !abonnementType) return 0;
    return abonnementTypes.findIndex(
      (abo) => abo.aboTypeId === abonnementType.aboTypeId
    );
  }, [abonnementTypes, abonnementType]);

  const handleAbonnementChange = useCallback(
    (evt) => {
      setAbonnementType(abonnementTypes[evt.target.value]);
    },
    [abonnementTypes]
  );
  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-text">{t('subscriptions.loadingTypes')}</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-alert">
        <h3>{t('subscriptions.errorLoading')}</h3>
        <p>{t('subscriptions.errorLoadingTypes')}</p>
      </div>
    );
  }

  if (!klant || !abonnementTypes) {
    return (
      <div className="error-alert">
        <h3>{t('common.error')}</h3>
        <p>{t('subscriptions.noCustomerSelected')}</p>
      </div>
    );
  }

  if (redirect) {
    return <Redirect to={`/klant/${klant.klantId}`} />;
  }

  return (
    <div className="page-wrapper">
      <div className="page-header">
        <h2>{isUpdate ? t('subscriptions.updateTitle') : t('subscriptions.addTitle')}</h2>
      </div>

      <div className="page-content">
        <div className="filter-bar">
          <h3>{t('subscriptions.details')}</h3>
          <div style={{ display: "flex", flexDirection: "column", gap: "0.75rem", maxWidth: "500px" }}>
            {abonnement && (
              <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
                <label style={{ fontWeight: "600", color: "#374151", minWidth: "120px" }}>{t('subscriptions.subscriptionIdLabel')}:</label>
                <input
                  className="filter-input"
                  type="text"
                  readOnly
                  value={abonnementId ?? ""}
                  style={{ backgroundColor: "#e5e7eb", color: "#6b7280", cursor: "not-allowed", width: "200px" }}
                />
              </div>
            )}
            <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
              <label style={{ fontWeight: "600", color: "#374151", minWidth: "120px" }}>{t('customers.debtorNumber')}:</label>
              <input
                className="filter-input"
                type="text"
                readOnly
                value={klant.debiNr ?? ""}
                style={{ backgroundColor: "#e5e7eb", color: "#6b7280", cursor: "not-allowed", width: "200px" }}
              />
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
              <label style={{ fontWeight: "600", color: "#374151", minWidth: "120px" }}>{t('customers.companyName')}:</label>
              <input
                className="filter-input"
                type="text"
                readOnly
                value={klant.naam ?? ""}
                style={{ backgroundColor: "#e5e7eb", color: "#6b7280", cursor: "not-allowed", width: "200px" }}
              />
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
              <label style={{ fontWeight: "600", color: "#374151", minWidth: "120px" }}>{t('subscriptions.typeLabel')}:</label>
              <select
                className="filter-input"
                style={{ width: "200px" }}
                onChange={handleAbonnementChange}
                value={selectAbonnementOption()}
              >
                {abonnementTypes.map((abo, i) => (
                  <option key={i} value={i}>
                    {abo.naam}
                  </option>
                ))}
              </select>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
              <label style={{ fontWeight: "600", color: "#374151", minWidth: "120px" }}>{t('subscriptions.quantityLabel')}:</label>
              <input
                className="filter-input"
                type="number"
                style={{ width: "200px" }}
                value={aantal}
                onChange={(evt) => setAantal(evt.target.value)}
              />
            </div>
            <RenderOnRole roles={["Administrator"]}>
              <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
                <label style={{ fontWeight: "600", color: "#374151", minWidth: "120px" }}>{t('subscriptions.startDate')}:</label>
                <input
                  className="filter-input"
                  type="date"
                  style={{ width: "200px" }}
                  value={startdatum ? startdatum.toString().split("T")[0] : ""}
                  onChange={(evt) => setStartdatum(evt.target.value)}
                />
              </div>
            </RenderOnRole>
            <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
              <label style={{ fontWeight: "600", color: "#374151", minWidth: "120px" }}>{t('subscriptions.endDate')}:</label>
              <input
                className="filter-input"
                type="date"
                style={{ width: "200px" }}
                value={einddatum ? einddatum.toString().split("T")[0] : ""}
                onChange={(evt) => setEinddatum(evt.target.value)}
              />
            </div>
          </div>
        </div>

        {responseMessage && (
          <div style={{ marginTop: "1rem", padding: "0.75rem", backgroundColor: "#fee2e2", color: "#991b1b", borderRadius: "0.375rem", border: "1px solid #fecaca" }}>
            {responseMessage}
          </div>
        )}

        <div className="action-bar" style={{ marginTop: "1.5rem" }}>
          <button className="btn btn-primary" onClick={postAbonnement}>
            {isUpdate ? t('subscriptions.updateTitle') : t('subscriptions.addTitle')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AbonnementToevoegenPagina;